import { Text, Box, Button, Modal, ModalOverlay, ModalContent, ModalHeader, ModalCloseButton, ModalBody, ModalFooter, HStack, Spinner, RadioGroup, Radio, Stack } from '@chakra-ui/react'
import React from 'react'
import { ICourse } from '@/shared/ICourse';
import { CourseStorageService } from '../services/CourseStorageService';
import { ErrorMessage } from '../components/ErrorMessage';
import { useOperation } from '../components/useOperation';
import { PLATFORM_VERSION } from '@/shared/constants';

export const NewRepeatedCourseDialog = (props: {
  onClose: () => void;
  onRepeatedCourseCreated?: (course: ICourse) => void;
  course: ICourse;
}) => {

  const [type, setType] = React.useState<string>(props.course.coursePlatformVersion === PLATFORM_VERSION.V1 ? '' : 'repeat_major_changes');

  const [onCreate, errorMessage, isProcessing] = useOperation(async () => {
    const course: Partial<ICourse> = {
      providerId: props.course.providerId,
      CourseTitle: props.course.CourseTitle,
      CourseIdentifier: props.course.CourseIdentifier,
      coursePreviousRunId: props.course.id,
      CourseSegment: props.course.CourseSegment,
      CourseProviderUsers: props.course.CourseProviderUsers,
      CourseStaffUsers: props.course.CourseStaffUsers,
      CourseDescription: props.course.CourseDescription,
      coursePlatformVersion: PLATFORM_VERSION.V2,
      CourseStatus: type,
    };

    // if (runs.some(r => r.LabelAwarded === AWARD_STATUS.AWARDED || r.LabelAwarded === AWARD_STATUS.AWARDED_EDITION)) {
    //   params.LabelAwarded = AWARD_STATUS.WAS_AWARDED;
    // }

    const created: ICourse = await CourseStorageService.createCourse(course);
    props.onRepeatedCourseCreated?.(created);
  }, [type, props.course]);

  const initialRef = React.useRef(null)

  return (
    <Modal
      initialFocusRef={initialRef}
      finalFocusRef={initialRef}
      size='xl'
      isOpen
      onClose={props.onClose}
      preserveScrollBarGap
    >
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Add a Repeated Course</ModalHeader>
        <ModalCloseButton />
        <ModalBody pb={6}>
          <ErrorMessage error={errorMessage} />
          {props.course.coursePlatformVersion === PLATFORM_VERSION.V1 ? <>
            <Text mb={4}>
              Please choose if there are major changes or no or minor changes.
              If there are major changes, the process will start at Step 1 and involve assessment by an external reviewer by default.
            </Text>
            <RadioGroup onChange={setType} value={type}>
              <Stack spacing={4}>
                <Radio value="repeat_major_changes">
                  <Box py='2'>
                    <Text fontSize='md'>A course that requires <strong>major changes</strong> or to reapply for the EIT Label</Text>
                    <Text fontSize='sm' color='gray.500'>Starts the process at the Step 1, and involves assessment by an external reviewer</Text>
                  </Box>
                </Radio>
                <Radio value="repeat_minor_changes">
                  <Box py='2'>
                    <Text>A course that requires only <strong>minor changes</strong> or no changes</Text>
                    <Text fontSize='sm' color='gray.500'>Starts the process at the Step 2, and involves EIT UM staff</Text>
                  </Box>
                </Radio>
              </Stack>
            </RadioGroup>
          </> : <>
            <Text mb={4}>
              {`This will create a new course with the same Step 1 content as the selected course "${props.course.CourseTitle}" with provider "${props.course.provider?.ProviderName}", 
              except for the date and file uploads.`}
            </Text>
          </>}
        </ModalBody>

        <ModalFooter>
          <Button variant='solid' isDisabled={!type || isProcessing} mr={4} onClick={onCreate}>
            <HStack spacing={2}>{isProcessing && <Spinner />}<Text>{isProcessing ? 'Adding Repeated Course...' : 'Add Repeated Course'}</Text></HStack>
          </Button>
          <Button variant='outline' onClick={props.onClose}>Cancel</Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}